import { useEffect } from 'react'
import styles from './RequestForRegistrationCardPage.module.css'
import Navbar from '../../components/Navbar/Navbar'
import HeaderForCard from '../../components/HeaderForCard/HeaderForCard'
import RequestForRegistrationMainInformation from '../../components/RequestForRegistrationMainInformation/RequestForRegistrationMainInformation'
import CustomButton from '../../components/UI/CustomButton/CustomButton'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import {
  acceptRegistrationRequests,
  getCurrentRegistrationRequests,
  rejectRegistrationRequests,
} from '../../redux/actions/registartionRequestAction'
import { useNavigate, useParams } from 'react-router-dom'
import Loader from '../../components/UI/Loader/Loader'
import PATH from '../../navigation/path'
import { createStatusForRegistrationRequest } from '../../utils/createRoleForRegister'
import { createStyleForRegistatironRequest } from '../../utils/createStatusForClaims'
import { useToast } from '../../context/ToastContext'

const RequestForRegistrationCardPage = () => {
  const { showSuccess, showError } = useToast()
  const { isLoading, currentRegistrationRequests } = useAppSelector(
    (state) => state.registrationRequest,
  )

  const { requestId } = useParams<{ requestId: string }>()

  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const handleReset = async () => {
    const resultAction = await dispatch(
      rejectRegistrationRequests({ requestId: String(currentRegistrationRequests.id) }),
    )

    if (rejectRegistrationRequests.rejected.match(resultAction)) {
      showError('Произошла ошибка при попытке отклонить заявку')
    } else {
      showSuccess('Заявка успешно отклонена')

      navigate(PATH.requestForRegistration)
    }
  }

  const handleSubmit = async () => {
    const resultAction = await dispatch(
      acceptRegistrationRequests({ requestId: String(currentRegistrationRequests.id) }),
    )

    if (acceptRegistrationRequests.rejected.match(resultAction)) {
      showError('Произошла ошибка при попытке подтвердить заявку')
    } else {
      showSuccess('Заявка успешно подтверждена')
      navigate(PATH.requestForRegistration)
    }
  }

  useEffect(() => {
    dispatch(getCurrentRegistrationRequests({ requestId }))
  }, [dispatch, requestId])

  if (isLoading) {
    return <Loader />
  }

  return (
    <div className={styles.requestCard}>
      <Navbar />
      <div className={styles.container}>
        <HeaderForCard
          status={
            <div className={createStyleForRegistatironRequest(currentRegistrationRequests.status)}>
              {createStatusForRegistrationRequest(currentRegistrationRequests.status)}
            </div>
          }
          title='Запрос на регистрацию'
        />
        <div className={styles.content}>
          <RequestForRegistrationMainInformation requestData={currentRegistrationRequests} />
        </div>
        {currentRegistrationRequests.status !== 'accepted' && (
          <div className={styles.btnsBlock}>
            <CustomButton
              type='reset'
              onClick={handleReset}
              title='Отклонить'
              className={styles.cancelBtn}
            />
            <CustomButton title='Принять' onClick={handleSubmit} type='submit' />
          </div>
        )}
      </div>
    </div>
  )
}

export default RequestForRegistrationCardPage
